export const MEETING_ROOM_SOLICITATIONS_PAGE_SIZE = 5

const RESERVATION_MEETING_ROOM_BASE = '/v1/hub/company/reservation-meeting-room'

export const RESERVATION_MEETING_ROOM_API = {
  BASE: RESERVATION_MEETING_ROOM_BASE,
  EXPORT: `${RESERVATION_MEETING_ROOM_BASE}/export`,
  byId: (id: string) => `${RESERVATION_MEETING_ROOM_BASE}/${id}`,
  update: (id: string) => `${RESERVATION_MEETING_ROOM_BASE}/${id}/update`,
  approve: (id: string) => `${RESERVATION_MEETING_ROOM_BASE}/${id}/approve`,
  reject: (id: string) => `${RESERVATION_MEETING_ROOM_BASE}/${id}/reject`,
  cancel: (id: string) => `${RESERVATION_MEETING_ROOM_BASE}/${id}/cancel`,
} as const

export enum ReservationStatusCode {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Cancelled = 4,
}
